export default __webpack_public_path__ + "static/media/Chevron-down.26b9d7d3.svg";